/**
 * Display pollution parameters message.
 * Click on "see details" to view more information.
 */
import React from "react";
import PropTypes from "prop-types";
import PulseLoader from "react-spinners/PulseLoader";
import { withTranslation } from "react-i18next";
import { Button } from "hesus-ui-kit";

import {
  PollutionParamsGoodMessage,
  PollutionParamsErrorMessage,
} from "../AddEditSolution.styled";

const PollutionParameterMessage = (props) => {
  const {
    t,
    showPollutionParamsDetails,
    centreProduct,
    isLoading,
    isPollutionParamsAvailable,
    subCategoryId,
  } = props;

  const POLLUTED_SOILS = 1;

  const btnStyles = {
    background: "#fff",
    "&:hover": {
      backgroundColor: "#bd5506",
      color: "white",
    },
    padding: "0 5px",
    border: "none",
    color: "#ED6B08",
    textTransform: "capitalize",
  };

  return (
    <>
      {isLoading && <PulseLoader color="#004c7f" size={10} />}
      {centreProduct &&
        !isLoading &&
        !isPollutionParamsAvailable &&
        subCategoryId === POLLUTED_SOILS && (
          <PollutionParamsGoodMessage>
            {t("POLLUTION_PARAMS_GOOD")}
          </PollutionParamsGoodMessage>
        )}
      {centreProduct &&
        !isLoading &&
        isPollutionParamsAvailable &&
        subCategoryId === POLLUTED_SOILS && (
          <div>
            <PollutionParamsErrorMessage>
              {t("POLLUTION_PARAMS_SHOW_RESULTS")}
            </PollutionParamsErrorMessage>
            <Button styles={btnStyles} onClick={showPollutionParamsDetails}>
              {t("SEE_DETAILS")}
            </Button>
          </div>
        )}
    </>
  );
};

PollutionParameterMessage.propTypes = {
  centreProduct: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  isLoading: PropTypes.bool.isRequired,
  isPollutionParamsAvailable: PropTypes.bool.isRequired,
  subCategoryId: PropTypes.number.isRequired,
  showPollutionParamsDetails: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PollutionParameterMessage);
